<div class="box">
  <div class="modal-header">
    <h2 class="modal-title pull-left mr-4">
      {{
        isEditMode
          ? ('BATCH_MAILING.BATCHES_TAB.ATTACHMENT_CARD.EDIT_ATTACHMENT'
            | translate)
          : ('BATCH_MAILING.BATCHES_TAB.ATTACHMENT_CARD.ADD_ATTACHMENT'
            | translate)
      }}
    </h2>
    <button
      type="button"
      class="close pull-right"
      title="{{ 'CLOSE' | translate }}"
      [attr.aria-label]="'CLOSE' | translate"
      (click)="hide('cancel')"
    ></button>
  </div>

  <div class="modal-body">
    <form
      [formGroup]="attachmentForm"
      #formEl
      id="attachmentForm"
      (ngSubmit)="submit(false)"
    >
      <article class="form-row">
        <section class="form-control">
          <label for="article">{{
            'BATCH_MAILING.BATCHES_TAB.ATTACHMENT_CARD.ARTICLE' | translate
          }}</label>
          <input
            type="text"
            formControlName="article"
            name="weight"
            [asterisk]="true"
            id="article"
          />
          @if (attachmentForm?.get('article')?.touched) {
            <app-custom-control-error
              [setErrors]="attachmentForm?.get('article')?.errors"
            >
            </app-custom-control-error>
          }
        </section>

        <section class="form-control">
          <label for="quantity">{{
            'BATCH_MAILING.BATCHES_TAB.ATTACHMENT_CARD.PRODUCT_QUANTITY'
              | translate
          }}</label>
          <input
            type="number"
            formControlName="quantity"
            name="quantity"
            id="quantity"
            [asterisk]="true"
            (keydown)="
              deleteSymbols($event, false, {
                currentValue: attachmentForm?.get('quantity')?.value,
                maxLength: 3,
              })
            "
          />
          @if (attachmentForm?.get('quantity')?.touched) {
            <app-custom-control-error
              [setErrors]="attachmentForm?.get('quantity')?.errors"
            >
            </app-custom-control-error>
          }
        </section>

        <section class="form-control">
          <label for="price">{{
            'BATCH_MAILING.BATCHES_TAB.ATTACHMENT_CARD.UNIT_COST' | translate
          }}</label>
          <input
            type="text"
            formControlName="price"
            name="price"
            [asterisk]="true"
            (keydown)="
              onFractionalDigitKeydown(
                $event,
                attachmentForm.get('price').value,
                5
              )
            "
            id="price"
          />
          @if (
            attachmentForm?.get('price')?.touched &&
            attachmentForm?.get('price')?.invalid
          ) {
            <app-custom-control-error
              [setErrors]="attachmentForm?.get('price')?.errors"
            >
            </app-custom-control-error>
          }
        </section>
      </article>

      <section class="form-control">
        <label for="name">{{
          'BATCH_MAILING.BATCHES_TAB.ATTACHMENT_CARD.NAME' | translate
        }}</label>
        <input
          type="text"
          formControlName="name"
          name="name"
          [asterisk]="true"
          (keydown)="
            onLatinCyrillicDigitsKeyDown(
              $event,
              attachmentForm.get('name').value,
              60
            )
          "
          id="name"
        />
        @if (attachmentForm?.get('name')?.touched) {
          <app-custom-control-error
            [setErrors]="attachmentForm?.get('name')?.errors"
          >
          </app-custom-control-error>
        }
      </section>

      <footer class="modal-footer">
        <p class="modal-footer-title">
          <span>{{
            'BATCH_MAILING.BATCHES_TAB.ATTACHMENT_CARD.TOTAL_COST_BYN'
              | translate
          }}</span>
          <span> {{ attachmentForm.get('total_price').value }}</span>
        </p>
        <section class="modal-footer-manage-btns">
          @if (!isEditMode) {
            <button
              type="button"
              [disabled]="
                (batchDeparture$ | async)?.partial_receipts_count >= 20 ||
                (isResponseLoading$ | async)
              "
              class="button button--outlined"
              (click)="submit(true)"
            >
              {{
                'BATCH_MAILING.BATCHES_TAB.ATTACHMENT_CARD.SAVE_WITHOUT_HIDING'
                  | translate
              }}
            </button>
          }

          <button
            class="button button--filled button--shadow"
            type="submit"
            [disabled]="
              ((batchDeparture$ | async)?.partial_receipts_count >= 20 &&
                !isEditMode) ||
              (isResponseLoading$ | async)
            "
            form="attachmentForm"
          >
            <span>{{
              isEditMode ? ('EDIT' | translate) : ('ADD' | translate)
            }}</span>

            @if (isEditMode && (isResponseLoading$ | async)) {
              <div class="spinner text-center ml-2">
                <div class="spinner-border spinner-border-sm" role="status">
                  <span class="sr-only">{{ 'LOADING' | translate }}</span>
                </div>
              </div>
            }
          </button>
        </section>
      </footer>
    </form>
  </div>
</div>
